import React, { useMemo } from 'react'
import OfferPageStateTrackingContext from './offerPageStateTrackingContext'
import useTrackOfferPageEvent from '../support/useTrackOfferPageEvent'

interface Props extends React.PropsWithChildren {
}

export function OfferPageStateTrackingProvider(props: Props) {
  const trackEvent = useTrackOfferPageEvent()

  const providerValue = useMemo(() => ({ trackEvent }), [trackEvent])

  return <OfferPageStateTrackingContext.Provider value={providerValue}>
    {props.children}
  </OfferPageStateTrackingContext.Provider>
}

export default OfferPageStateTrackingProvider
